import {EditorView} from '@codemirror/view'
import {BoldIcon, CodeIcon, ItalicIcon, LinkIcon} from '@primer/octicons-react'
import {ActionBar} from '@primer/react'

import {formatBold, formatInlineCode, formatItalic} from '../codemirror/commands/inline-formatting'
import {insertLink} from '../codemirror/commands/insert-link'
import {useSelectionContext} from '../context/SelectionContext'
import styles from './Toolbar.module.css'
import {ToolbarButton} from './ToolbarButton'

interface ToolbarProps {
  view: EditorView | null
}

function clickIfEditorFocused(view: EditorView | null, clickHandler: (view: EditorView) => void) {
  if (view?.hasFocus) {
    clickHandler(view)
  }
}

export const Toolbar = ({view}: ToolbarProps) => {
  const {inBold, inInlineCode, inItalics} = useSelectionContext()

  return (
    <ActionBar aria-label="Formatting tools" className={styles.actionBar}>
      <ToolbarButton
        aria-label="Bold"
        aria-pressed={inBold}
        icon={BoldIcon}
        onClick={() => {
          clickIfEditorFocused(view, formatBold)
        }}
      />
      <ToolbarButton
        aria-label="Italic"
        aria-pressed={inItalics}
        icon={ItalicIcon}
        onClick={() => {
          clickIfEditorFocused(view, formatItalic)
        }}
      />

      <ToolbarButton
        aria-label="Link"
        icon={LinkIcon}
        onClick={() => {
          clickIfEditorFocused(view, insertLink)
        }}
      />
      <ToolbarButton
        aria-label="Code"
        aria-pressed={inInlineCode}
        icon={CodeIcon}
        onClick={() => {
          clickIfEditorFocused(view, formatInlineCode)
        }}
      />
      {/* <ToolbarButton onClick={() => {}} icon={QuoteIcon} aria-label="Quote" /> */}
      {/* <ActionBar.Divider /> */}
      {/* <ToolbarButton onClick={() => {}} icon={ListUnorderedIcon} aria-label="Unordered list" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={ListOrderedIcon} aria-label="Numbered list" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={TasklistIcon} aria-label="Task list" /> */}
      {/* <ActionBar.Divider /> */}
      {/* <ToolbarButton onClick={() => {}} icon={PaperclipIcon} aria-label="Attachment" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={ReplyIcon} aria-label="Saved replies" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={DiffIgnoredIcon} aria-label="Slash commands" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={AlertIcon} aria-label="Alert" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={CodeSquareIcon} aria-label="Code block" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={TableIcon} aria-label="Table" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={MultiSelectIcon} aria-label="Details" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={SquareIcon} aria-label="Footnote" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={HeadingIcon} aria-label="Heading" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={HorizontalRuleIcon} aria-label="Horizontal Rule" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={NumberIcon} aria-label="Math block" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={CrossReferenceIcon} aria-label="Reference" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={StrikethroughIcon} aria-label="Strikethrough" /> */}
    </ActionBar>
  )
}
Toolbar.displayName = 'HybridMarkdownEditor.Toolbar'
